import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '@/types/queryKey';
import {
  getUserRoles,
  getUsersList,
  saveUserAccount,
} from '@/lib/services/admin';

import { useAxiosErrorHandler } from './common';

export function useGetUsers(page: number, pageSize: number) {
  const { parseAndShowError } = useAxiosErrorHandler();

  return useQuery({
    queryKey: [QueryKey.UsersList, page, pageSize],
    queryFn: () => getUsersList(page, pageSize),
    retry: (_failureCount, error) => {
      parseAndShowError(error);
      return false;
    },
  });
}

export function useGetUserRoles() {
  const { parseAndShowError } = useAxiosErrorHandler();

  return useQuery({
    queryKey: [QueryKey.UsersList],
    queryFn: () => getUserRoles(),
    retry: (_failureCount, error) => {
      parseAndShowError(error);
      return false;
    },
  });
}

export function useSaveUserAccount() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveUserAccount,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.UsersList] });
    },
  });
}
